module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.4-card-preview.61ae6fa8.png";